import { Link } from "@tanstack/react-router";
import { MessageSquareText, UserRound, type LucideIcon } from "lucide-react";

import { FICHA_TABS, type FichaTab, PessoaLabels } from "@/lib/labels";
import { cn } from "@/lib/utils";

const TAB_ICON: Record<FichaTab, LucideIcon> = {
	cadastro: UserRound,
	conversa: MessageSquareText,
};

const FichaTabs = {
	visible(gates: { hasChannel: boolean }) {
		return FICHA_TABS.filter((tab) => {
			if (tab === "conversa") {
				return gates.hasChannel;
			}

			return true;
		});
	},
};

export function FichaTabsBar({
	id,
	tab,
	hasChannel,
}: {
	id: number;
	tab: FichaTab;
	hasChannel: boolean;
}) {
	const tabs = FichaTabs.visible({ hasChannel });

	return (
		<nav
			data-component="ficha-tabs"
			className="flex items-center gap-4 border-b border-border bg-card px-4 sm:px-5"
		>
			{tabs.map((value) => {
				const Icon = TAB_ICON[value];

				return (
					<Link
						key={value}
						to="/pessoa/$id"
						params={{ id }}
						search={(prev) => ({ ...prev, tab: value })}
						data-slot="tab"
						data-tab={value}
						aria-current={value === tab ? "page" : "false"}
						className={cn(
							"workspace-tab min-w-0 flex-1 justify-center sm:flex-none",
							value === tab
								? "border-primary text-primary"
								: "border-transparent text-muted-foreground hover:text-foreground",
						)}
					>
						<Icon className="size-4" />
						<span className="truncate">{PessoaLabels.fichaTabs[value]}</span>
					</Link>
				);
			})}
		</nav>
	);
}
